import React from "react";
import "./featureSection.css";
import featureImageOne from "../../images/01 AI Guardrails.svg";
import featureImageTwo from "../../images/02 Risk Mitigation.svg";
import featureImageThree from "../../images/03 Quality Assurance.svg";
import featureImageFour from "../../images/04 Continuous Monitoring and Reporting.svg";
import featureImageFive from "../../images/05 Bias Detection and Correction.svg";
import ScrollReveal from "../scrollReveal/scrollReveal";

export default function FeaturesSection() {
  return (
    <ScrollReveal>
      <section class="features-section">
        <div class="container">
          <div class="section-wrapper feature-section-wrapper">
            <div className="section-heading">
              <div className="heading-tag">
                <span>FEATURES</span>
              </div>
              <div className="heading-description">
                <div>
                  <h2>
                    Ensuring AI Trust and Assurance with Design by Privacy and
                    Safety{" "}
                  </h2>
                </div>
                <p>
                  Explore Agentic AI Trust Score features designed to ensure
                  trust, reliability, and assurance in your AI solutions,
                  empowering secure and ethical operations.
                </p>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 feature-card">
              <div class="content-group">
                <div class="row ">
                  <div class="col-12 col-sm-6 col-md-4 col-lg-4 feature-card">
                    <div class="tabs-card-row1">
                      <div class="tab-content-wrapper">
                        <h3>Ethical Guardrails Integration </h3>
                        <p>
                          Incorporate safeguards to align AI actions with
                          ethical and operational standards.
                        </p>
                      </div>
                      <img src={featureImageOne} alt="dynamic-ai-guardrails" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-4 feature-card">
                    <div class="tabs-card-row1">
                      <div class="tab-content-wrapper">
                        <h3>Proactive Risk Mitigation</h3>
                        <p>
                          Identify and address potential risks with advanced
                          predictive analytics and monitoring.
                        </p>
                      </div>
                      <img
                        src={featureImageTwo}
                        alt="proactive-risk-mitigation"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-4 feature-card">
                    <div class="tabs-card-row1">
                      <div class="tab-content-wrapper">
                        <h3>Comprehensive Quality Metrics</h3>
                        <p>
                          Ensure consistent AI excellence through robust quality
                          assurance frameworks.
                        </p>
                      </div>
                      <img
                        src={featureImageThree}
                        alt="comprehensive-quality-assurance"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6 feature-card">
                    <div class="tabs-card-row1">
                      <div class="tab-content-wrapper">
                        <h3>Dynamic Trust Scoring </h3>
                        <p>
                          Continuously evaluate and monitor AI performance with
                          real-time trust scores for transparency.
                        </p>
                      </div>
                      <img src={featureImageFour} alt="network-image" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6 feature-card">
                    <div class="tabs-card-row1 ">
                      <div class="tab-content-wrapper">
                        <h3>Bias Detection and Elimination </h3>
                        <p>
                          Leverage advanced tools to detect, prevent, and
                          mitigate biases in AI systems.
                        </p>
                      </div>
                      <img
                        src={featureImageFive}
                        alt="bias-detection-correction"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ScrollReveal>
  );
}
